import Button from '../components/button';

const Settings = ({ darkMode, setDarkMode}) => {

    const activateDarkMode = () => {
        if (darkMode) {
            setDarkMode(false)
        } else {
            setDarkMode(true)
        }
    }

    return (
        <div className="settings">
            <Button className={darkMode ? "hvr-sweep-to-right" : "hvr-sweep-to-right-light-mode"} onClick={activateDarkMode} name={darkMode ? "Light mode" : "Dark mode"}></Button>
        </div>
    );
}

export default Settings;
